module.exports = __webpack_public_path__ + "img/dataPark3.d6263638.png";